'use client';

import React from 'react';

interface FormGridProps {
  children: React.ReactNode;
  columns?: 1 | 2;
  className?: string;
}

export const FormGrid: React.FC<FormGridProps> = ({
  children,
  columns = 2,
  className = '',
}) => {
  const colsClass =
    columns === 2 ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : 'grid grid-cols-1 gap-4';

  return <div className={`${colsClass} ${className}`}>{children}</div>;
};

